export const normalizePath = (s: string) => s.replace(/^\/+/, '')
